import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

export const HoverInfo = ({
  color = '#B5BCC4',
  description,
  fontSize = '20px',
  title,
}: {
  color?: string;
  description: string;
  fontSize?: string;
  title?: string;
}) => {
  return (
    <Box
      sx={{
        alignItems: 'center',
        cursor: 'pointer',
        display: 'flex',
      }}
    >
      <Tooltip
        title={
          <Stack gap={1}>
            {title && (
              <Typography color="text.primary" variant="body2">
                {title}
              </Typography>
            )}
            {description && (
              <Typography color="text.secondary" sx={{ fontSize: 12 }} variant="body2">
                {description}
              </Typography>
            )}
          </Stack>
        }
      >
        <InfoOutlinedIcon sx={{ color, fontSize }} />
      </Tooltip>
    </Box>
  );
};
